module.exports = __webpack_public_path__ + "images/help/video-todos-small-7e01a556a4cb941a513b99af042798b3.png";